module.exports = __webpack_public_path__ + "static/img/merchant-logo.ea9bb70.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/merchants-entering/merchant-logo.png
// module id = j2ba
// module chunks = 0